/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nfp_Faq_3_AInputs */

const en_nfp_faq_3_a = /** @type {(inputs: Nfp_Faq_3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. The Community Hub can be set to 'Private', meaning members must request access before joining the live discussions or accessing secure materials.`)
};

const es_nfp_faq_3_a = /** @type {(inputs: Nfp_Faq_3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. El Centro de la Comunidad puede configurarse como 'Privado', por lo que los miembros deben solicitar acceso antes de unirse a las discusiones.`)
};

const fr_nfp_faq_3_a = /** @type {(inputs: Nfp_Faq_3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Le Centre communautaire peut être défini sur 'Privé', ce qui signifie que les membres doivent demander l'accès avant de rejoindre les discussions en direct ou d'accéder au matériel sécurisé.`)
};

const de_nfp_faq_3_a = /** @type {(inputs: Nfp_Faq_3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Der Community-Hub kann auf 'Privat' gesetzt werden.`)
};

const id_nfp_faq_3_a = /** @type {(inputs: Nfp_Faq_3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya. Hub Komunitas dapat diatur menjadi 'Pribadi', yang berarti anggota harus meminta akses sebelum bergabung dengan diskusi langsung atau mengakses materi yang aman.`)
};

/** @type {(inputs: Nfp_Faq_3_AInputs) => LocalizedString} */
const ja_nfp_faq_3_a = en_nfp_faq_3_a;

/** @type {(inputs: Nfp_Faq_3_AInputs) => LocalizedString} */
const zh_nfp_faq_3_a = en_nfp_faq_3_a;

/** @type {(inputs: Nfp_Faq_3_AInputs) => LocalizedString} */
const ar_nfp_faq_3_a = en_nfp_faq_3_a;

/** @type {(inputs: Nfp_Faq_3_AInputs) => LocalizedString} */
const it_nfp_faq_3_a = en_nfp_faq_3_a;

/** @type {(inputs: Nfp_Faq_3_AInputs) => LocalizedString} */
const ru_nfp_faq_3_a = en_nfp_faq_3_a;

/** @type {(inputs: Nfp_Faq_3_AInputs) => LocalizedString} */
const pt_nfp_faq_3_a = en_nfp_faq_3_a;

/** @type {(inputs: Nfp_Faq_3_AInputs) => LocalizedString} */
const ko_nfp_faq_3_a = en_nfp_faq_3_a;

/**
* | output |
* | --- |
* | "Yes. The Community Hub can be set to 'Private', meaning members must request access before joining the live discussions or accessing secure materials." |
*
* @param {Nfp_Faq_3_AInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nfp_faq_3_a = /** @type {((inputs?: Nfp_Faq_3_AInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nfp_Faq_3_AInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nfp_faq_3_a(inputs)
	if (locale === "es") return es_nfp_faq_3_a(inputs)
	if (locale === "fr") return fr_nfp_faq_3_a(inputs)
	if (locale === "de") return de_nfp_faq_3_a(inputs)
	if (locale === "ja") return ja_nfp_faq_3_a(inputs)
	if (locale === "zh") return zh_nfp_faq_3_a(inputs)
	if (locale === "ar") return ar_nfp_faq_3_a(inputs)
	if (locale === "id") return id_nfp_faq_3_a(inputs)
	if (locale === "it") return it_nfp_faq_3_a(inputs)
	if (locale === "ru") return ru_nfp_faq_3_a(inputs)
	if (locale === "pt") return pt_nfp_faq_3_a(inputs)
	return ko_nfp_faq_3_a(inputs)
});